// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./common/services/messages/msg.service.scss
// module id = 932
// module chunks = 0